import * as Sentry from "@sentry/react";

const flushTimeoutMs = 1000;

export async function flushSentry(): Promise<boolean> {
  try {
    return await Sentry.flush(flushTimeoutMs);
  } catch {
    return false;
  }
}
